import type { FC, PropsWithChildren } from 'react'
import { useState } from 'react'
import styled from '@emotion/styled'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import Elevation from '@segment/matcha/components/Elevation'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CoverImage from './CoverImage'

const Video: FC<PropsWithChildren<unknown>> = () => {
  const [playing, setPlaying] = useState(false)
  const play = () => setPlaying(true)
  const stop = () => setPlaying(false)

  return (
    <StyledSection variant="noCopy">
      <Section.Contents>
        <StyledElevation elevation={6}>
          <VideoPlayerBase
            url="https://player.vimeo.com/video/559103187?badge=0&autopause=0&player_id=0&app_id=58479"
            playing={playing}
            onPause={() => {
              stop()
            }}
            onPlay={() => {
              play()
            }}
          >
            {!playing && <VideoPlayer.BigPlayButton onClick={play} key="play-btn" />}
            {!playing && <CoverImage key="cover" />}
          </VideoPlayerBase>
        </StyledElevation>
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-bottom: 64px;
    }
  }
`
const StyledElevation = styled(Elevation)`
  margin: 0 auto;
  max-width: 832px;
`

export default Video
